export const buildDefaultHCPPatientFormValues = () => {
  return {
    address: {
      city: "",
      state: "New York",
      street: "",
      zip_code: "",
    },
    child_sms_consent: false,
    consent: [],
    default_child_practice_autofill: false,
    dob: "",
    email: "",
    email_validation: "",
    emergency_contact_no: "",
    emergency_name: "",
    first_name: "",
    gender: "",
    is_spmi: false,
    last_name: "",
    medication_management_services: null,
    mobile: "",
    pcp_id: "",
    secondary_insurance: {
      card_back: "",
      card_front: "",
      carrier: "",
      group_id: "",
      member_id: "",
      policy_holder_name: "",
      state: "",
    },
  };
};
